import {useEffect, useState} from "react";
import {useForm, Controller, useWatch} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Col, Row } from "antd";
import {
    Button,
    Loading
} from "~/components";
import {
    InputField,
    GroupRadioField,
    SelectUserAll,
    SelectField
} from "~/components/Forms";
import {
    getWardOptionByProvinceId,
    provinceChange
} from "../../../../utils";
import {
    useProvince
} from "../../../../hooks";

function CustomerFormResendPass({item, onHandleSubmit}) {

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(false);
    }, [item.id])

    const onSubmit = async () =>
    {
        setLoading(true);
        await onHandleSubmit(item);
        setLoading(false);
    }

    return (
        <div className="form">
            <p>Mật khẩu đăng nhập của khách hàng sẽ được tạo mới và gửi lại vào mail <b>{item.email}</b></p>
            <div className="form-group d-flex justify-content-end modal-bottom">
                <Button primary onClick={onSubmit} loading={loading}>Gửi lại</Button>
            </div>
        </div>
    )
}

export default CustomerFormResendPass;